/** Single platform-owned example scenario (trainer+ only via API; not merged for sales-only lists). */
export const PLATFORM_TRAINER_EXAMPLE_KEY = "platform_trainer_example" as const;

export const PLATFORM_TRAINER_EXAMPLE_SCENARIO = {
  key: PLATFORM_TRAINER_EXAMPLE_KEY,
  label: "Platform example (generic shopper)",
  persona:
    "You are a shopper in a generic retail conversation. Ask simple, realistic questions about the product or service. " +
    "Stay brief and conversational. Do not assume any specific industry (no sheds, vehicles, or specialized jargon). " +
    "If the salesperson uses terms you do not understand, ask what they mean.",
} as const;
